// Flow types automatically removed

/**
 * All validation functions must accept a value and return a boolean
 * @param value: the inputs current value that requires validation
 * @returns boolean: true if value is valid; false if value is invalid
 */

/* Single email */
const email = value => {
    const emailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,100}$/i;
    return emailFormat.test(value.trim());
};
/* Multiple, comma-separated emails */

const emails = value => {
    const addresses = value.split(',');
    let i = 0;
    let isValid = addresses.length > 0;

    while (isValid && i < addresses.length) {
        isValid = email(addresses[i]);
        i++;
    }

    return isValid;
};
/* Default error messages for validation that return false */

const errorMessages = {
    email: 'Invalid Email',
    emails: 'Invalid Email(s)',
};
export default {
    email,
    emails,
    errorMessages,
};
